import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter, first } from 'rxjs/operators';
import { InterviewDefaultDataProviderService } from 'src/app/shared/interview-new/instances/data-providers/interview-default-data-provider.service';
import { AppStateModel } from '../+redux/redux.models';
import { MemberService } from '../member/member.service';

@Injectable()
export class InterviewMemberAssessmentDataProviderService extends InterviewDefaultDataProviderService {

    constructor(private store: Store,
        private memberService: MemberService
    ) {
        super();
    }

    async generateContextData(contextData: any, input?: any) {
        // wait until have member context
        const memberPayload = (await this.memberService.getCurrentMemberRequestPayload().pipe(filter(_ => !!_), first()).toPromise());

        // Leonardo 2023-07-19 The backend is throwing error for duplicated metadata(case insensitive)
        if (memberPayload) {
            delete memberPayload['metadata'];
            delete memberPayload['metaData'];
        }

        return {
            ...(await super.generateContextData(contextData)),
            ...memberPayload,
            Member: this.memberService.memberSync,
            entityId: contextData?.EntityId || this.store.selectSnapshot<string>((state: AppStateModel) => state.memberState.currentSession.memberId),
            entityType: contextData?.entityType || 'member',
            tenantId: contextData?.tenantId || this.store.selectSnapshot<string>((state: AppStateModel) => state.memberState.currentSession.tenantId),
        };
    }
}
